import { Platform } from 'react-native';
export const fontConfig = {
  Roboto: {
    100: {
      normal: Platform.select({
        ios: 'Roboto-Light',
        android: 'Roboto-Light',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-LightItalic',
        android: 'Roboto-LightItalic',
        web: 'Roboto'
      })
    },
    200: {
      normal: Platform.select({
        ios: 'Roboto-Light',
        android: 'Roboto-Light',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-LightItalic',
        android: 'Roboto-LightItalic',
        web: 'Roboto'
      })
    },
    300: {
      normal: Platform.select({
        ios: 'Roboto-Light',
        android: 'Roboto-Light',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-LightItalic',
        android: 'Roboto-LightItalic',
        web: 'Roboto'
      })
    },
    400: {
      normal: Platform.select({
        ios: 'Roboto-Regular',
        android: 'Roboto-Regular',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-Italic',
        android: 'Roboto-Italic',
        web: 'Roboto'
      })
    },
    500: {
      normal: Platform.select({
        ios: 'Roboto-Medium',
        android: 'Roboto-Medium',
        web: 'Roboto'
      })
    },
    600: {
      normal: Platform.select({
        ios: 'Roboto-Medium',
        android: 'Roboto-Medium',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-MediumItalic',
        android: 'Roboto-MediumItalic',
        web: 'Roboto'
      })
    },
    700: {
      normal: Platform.select({
        ios: 'Roboto-Bold',
        android: 'Roboto-Bold',
        web: 'Roboto'
      })
    },
    800: {
      normal: Platform.select({
        ios: 'Roboto-Bold',
        android: 'Roboto-Bold',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-BoldItalic',
        android: 'Roboto-BoldItalic',
        web: 'Roboto'
      })
    },
    900: {
      normal: Platform.select({
        ios: 'Roboto-Bold',
        android: 'Roboto-Bold',
        web: 'Roboto'
      }),
      italic: Platform.select({
        ios: 'Roboto-BoldItalic',
        android: 'Roboto-BoldItalic',
        web: 'Roboto'
      })
    }
  }
};
//# sourceMappingURL=index.js.map